import React from "react";
import { Field } from "formik";
import { Checkbox } from "components/Form/SpecialButtons";
import { Card, Image } from "semantic-ui-react";

const styles = {
	tubeContainer: {},
	content: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		flexWrap: "wrap",
	},
	selectPhoto: {
		cursor: "pointer",
		padding: 0,
		":hover": {
			backgroundColor: "rgba(0,0,0,0.1)",
		},
	},
	cardSelect: {
		":hover": {
			backgroundColor: "rgba(0,0,0,0.1)",
		},
	},
};
const AliquotForm = ({ element, tubesAliquotsFactory }) => {
	return (
		<div>
			<Field customlabel="Ce tube est un aliquot" component={Checkbox} name="aliquot" id="aliquot" disabled />
			{element.primary && (
				<div>
					<span>Tube primaire : </span>

					<Card style={{ margin: "auto", ...styles.cardSelect }}>
						<Card.Content style={styles.content}>
							{element.primary.picto && (
								<Image
									style={{ marginBottom: "1em" }}
									size="tiny"
									src={`${process.env.REACT_APP_BASE_URL}/tubePictos/${element.primary.picto.filename}`}
								/>
							)}
							<Card.Header style={{ width: "100%", textAlign: "center" }}>{element.primary.code}</Card.Header>
							<Card.Meta>{element.primary.label}</Card.Meta>
						</Card.Content>
					</Card>
				</div>
			)}
			{element.aliquots && element.aliquots.length > 0 && (
				<div>
					<span>Aliquots liés à ce tube : </span>
					{element.aliquots.map((a) => (
						<Card key={`aliquot-${a.id}`} style={{ margin: "auto", ...styles.cardSelect }}>
							<Card.Content style={styles.content}>
								{a.picto && (
									<Image style={{ marginBottom: "1em" }} size="tiny" src={`${process.env.REACT_APP_BASE_URL}/tubePictos/${a.picto.filename}`} />
								)}
								<Card.Header style={{ width: "100%", textAlign: "center" }}>{a.code}</Card.Header>
								<Card.Meta>{a.label}</Card.Meta>
							</Card.Content>
						</Card>
					))}
				</div>
			)}
		</div>
	);
};

export default AliquotForm;
